import { Link } from "react-router-dom";
import { ArrowUpRight, MessageSquare, Sparkles } from "lucide-react";
import BrandLogo from "@/components/BrandLogo";
import Reveal from "@/components/landing/Reveal";
import { renderTitle, toFullUrl } from "@/components/landing/utils";
import { LANDING } from "@/constants/testIds";

export default function CTAFinalSection({ block, brand }) {
  const bg = toFullUrl(block?.bg_image);
  const wa = brand?.whatsapp ? `https://wa.me/${brand.whatsapp}?text=${encodeURIComponent("Hola, me interesa el Proyecto Diamante de Rubí Perfumería")}` : null;
  return (
    <section className="section-onyx on-onyx py-24 md:py-32 relative overflow-hidden" data-testid="cta-final-section">
      {bg && <img src={bg} alt="" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover scale-105 blur-[3px] opacity-40" />}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/80 via-[#0A0A0A]/60 to-[#0A0A0A]/90" />
      <div className="gold-glow" style={{ width: 700, height: 700, top: -200, left: "50%", transform: "translateX(-50%)", opacity: 0.35 }} />
      <div className="max-w-[1000px] mx-auto px-6 lg:px-10 relative">
        <div className="relative glass-elev p-10 md:p-16 text-center corner-frame">
          <div className="absolute -top-14 left-1/2 -translate-x-1/2 float">
            <BrandLogo size={64} />
          </div>
          <Reveal>
            <div className="mt-8">
              <span className="pill pill-gold"><Sparkles size={12} /> {block?.eyebrow || "Convocatoria abierta · cupos limitados"}</span>
            </div>
          </Reveal>
          <Reveal delay={120}>
            <h2 className="mt-6 font-display text-3xl md:text-5xl lg:text-6xl text-[#0A0A0A]">
              {renderTitle(block?.title || "Los espacios del Proyecto Diamante <em>se están agotando</em>.")}
            </h2>
          </Reveal>
          {block?.body && (
            <Reveal delay={220}>
              <p className="mt-6 text-[#3F3F46] text-base md:text-lg max-w-2xl mx-auto leading-relaxed">{block.body}</p>
            </Reveal>
          )}
          <Reveal delay={340}>
            <div className="mt-10 flex flex-wrap gap-3 justify-center">
              <Link to="/calificacion" data-testid={LANDING.footerCtaForm} className="btn-primary">
                Evaluar mi participación <ArrowUpRight size={16} />
              </Link>
              {wa && (
                <a href={wa} target="_blank" rel="noreferrer" data-testid={LANDING.heroCtaWhatsapp} className="btn-outline">
                  <MessageSquare size={14} /> Hablar por WhatsApp
                </a>
              )}
            </div>
          </Reveal>
          {block?.microcopy && (
            <Reveal delay={480}>
              <div className="mt-6 text-[10px] uppercase tracking-widest text-[#52525B] font-mono">{block.microcopy}</div>
            </Reveal>
          )}
        </div>
      </div>
    </section>
  );
}
